import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isTelephonySelector } from '../selectors/selectors'

export function useIsTelephony() {
  return useSelector<RootState, boolean>(isTelephonySelector)
}
